import { render, staticRenderFns } from "./ResourceMap.vue?vue&type=template&id=115248d4&"
import script from "./ResourceMap.vue?vue&type=script&lang=js&"
export * from "./ResourceMap.vue?vue&type=script&lang=js&"
import style0 from "./ResourceMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports